// import React from "react";
// import { Outlet } from "react-router-dom";
// import HeaderDoc from "../components/payslip/HeaderDoc";
// import FooterDoc from "../components/payslip/FooterDoc";

// const LayoutDocuments = () => {
//   return (
//     <>
//       <div className="w-full mx-auto">
//         <HeaderDoc />
//         <main>
//           <Outlet />
//         </main>
//         <FooterDoc />
//         <div id="datepicker-portal" />
//       </div>
//     </>
//   );
// };

// export default LayoutDocuments;

import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiX,
  FiFileText,
  FiCalendar,
  FiCreditCard,
  FiClipboard,
  FiClock,
  FiDollarSign,
  FiDownload,
  FiAlertTriangle,
  FiAlertCircle,
} from "react-icons/fi";
import HeaderDoc from "../components/payslip/HeaderDoc";
import FooterDoc from "../components/payslip/FooterDoc";

import { LuFileText } from "react-icons/lu";
import {
  MdCurrencyExchange,
  MdOutlineDescription,
  MdOutlinePrint,
  MdOutlineReceiptLong,
} from "react-icons/md";
import {
  FaFileCircleCheck,
  FaFileCircleXmark,
  FaFileSignature,
  FaMoneyBillTrendUp,
  FaPrint,
} from "react-icons/fa6";
import { FileCheck, FilePenLine } from "lucide-react";
import { FaFileInvoiceDollar } from "react-icons/fa";
const menuItems = [
  {
    label: "Payslip Generator",
    icon: <MdOutlineReceiptLong />,
    path: "/hr-documents/payslip-generator",
  },
  {
    label: "Offer Letter",
    icon: <FaFileSignature />,
    path: "/hr-documents/offer-letter-generator",
  },
  {
    label: "Appointment Letter",
    icon: <FiCreditCard />,
    path: "/hr-documents/appointment-letter-generator",
  },
  {
    label: "Experience Letter",
    icon: <FaPrint />,
    path: "/hr-documents/experience-letter-generator",
  },

  {
    label: "Relieving Letter",
    icon: <FileCheck />,
    path: "/hr-documents/relieving-letter-generator",
  },
  {
    label: "Promotion Letter",
    icon: <FilePenLine />,
    path: "/hr-documents/promotion-letter-generator",
  },
  {
    label: "Salary Increment Letter",
    icon: <FaMoneyBillTrendUp />,
    path: "/hr-documents/salaryincrement-letter-generator",
  },
  {
    label: "Salary Revision Letter",
    icon: <MdCurrencyExchange />,
    path: "/hr-documents/salaryrevision-letter-generator",
  },
  // {
  //   label: "Confirmation Letter",
  //   icon: <FaFileCircleCheck />,
  //   path: "/hr-documents/confirmation-letter-generator",
  // },
  {
    label: "Warning Letter",
    icon: <FiAlertTriangle />,
    path: "/hr-documents/warning-letter-generator",
  },
  // {
  //   label: "Show Cause Notice Letter",
  //   icon: <FiAlertCircle />,
  //   path: "/hr-documents/show-cause-notice-letter-generator",
  // },
  // {
  //   label: "Termination Letter",
  //   icon: <FaFileCircleXmark />,
  //   path: "/hr-documents/termination-letter-generator",
  // },
];

const LayoutDocuments = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const activeItem = menuItems.find((item) =>
    location.pathname.startsWith(item.path),
  );

  const activeMenu = activeItem?.label || "Payslip Generator";

  const handleMenuClick = (item) => {
    setMobileMenuOpen(false);
    navigate(item.path);
  };

  return (
    <div className="min-h-screen w-full bg-[#D1DFEA] text-[#10324F]">
      {/* ================= HEADER ================= */}
      <HeaderDoc />

      {/* ================= MOBILE HEADER ================= */}
      <header className="sticky top-0 z-40 flex h-16 items-center gap-3 border-b border-[#10324F]/10 bg-[#dce8f1]/95 px-4 backdrop-blur md:hidden">
        <button
          type="button"
          onClick={() => setMobileMenuOpen(true)}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#10324F] text-white"
          aria-label="Open menu"
        >
          <FiMenu size={20} />
        </button>

        <div className="text-sm font-bold text-[#10324F]">{activeMenu}</div>
      </header>

      {/* ================= MOBILE DRAWER ================= */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-100 bg-black/40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        >
          <aside
            className="h-full w-70 max-w-[85%] bg-[#D1DFEA] shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex h-16 items-center justify-between border-b border-[#10324F]/10 px-4">
              <span className="font-semibold text-[#10324F]">{activeMenu}</span>

              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-[#10324F]/10"
              >
                <FiX size={20} />
              </button>
            </div>

            <SidebarContent
              activeMenu={activeMenu}
              onMenuClick={handleMenuClick}
            />
          </aside>
        </div>
      )}

      {/* ================= MAIN DOCUMENT AREA ================= */}
      <div className="mx-auto flex w-full items-start">
        {/* DESKTOP SIDEBAR */}
        <aside className="sticky top-20 hidden w-58 shrink-0 self-start px-4 py-5 md:block">
          <SidebarContent
            activeMenu={activeMenu}
            onMenuClick={handleMenuClick}
          />
        </aside>

        {/* PAGE CONTENT */}
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>

      {/* ================= FOOTER ================= */}
      <FooterDoc />

      {/* ================= DATE PICKER PORTAL ================= */}
      <div id="datepicker-portal" />
    </div>
  );
};

/* =========================================================
   SIDEBAR
========================================================= */

function SidebarContent({ activeMenu, onMenuClick }) {
  return (
    <div className="flex h-full flex-col px-4 sm:px-0">
      <div className="mb-4 px-2">
        <div className="hidden text-sm font-bold text-[#10324F] md:block">
          {/* Waggex logo if required */}
        </div>
      </div>

      <nav className="space-y-1">
        {menuItems.map((item) => {
          const isActive = activeMenu === item.label;

          return (
            <button
              key={item.path}
              type="button"
              onClick={() => onMenuClick(item)}
              className={`group flex w-full items-center gap-3 rounded-[3px] px-3 py-2.5 text-left transition ${
                isActive
                  ? "bg-[#10324F] text-white shadow-sm"
                  : "text-[#10324F] hover:bg-white/60"
              }`}
            >
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center text-base ${
                  isActive ? "text-white" : "text-[#10324F]"
                }`}
              >
                {item.icon}
              </span>

              <span className="text-xs font-medium sm:text-sm">
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

export default LayoutDocuments;
